import * as types from "../actions/types";
import modeleCleaner, { coordToObject } from "../utils/modele-cleaner";

const comparisons = ({ segments }) => {
  const modele = modeleCleaner(segments.modele);
  const copie = modeleCleaner(segments.copie);
  if (modele.length !== copie.length) return false;
  return modele.reduce((identique, segment, index) => {
    const coordModele = coordToObject(segment);
    const coordCopie = coordToObject(copie[index]);
    return identique
      ? coordModele.xi === coordCopie.xi &&
          coordModele.yi === coordCopie.yi &&
          coordModele.xf === coordCopie.xf &&
          coordModele.yf === coordCopie.yf
      : false;
  }, true);
};

const initialState = { isOpen: false, result: null };

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.COMPARE_WITH_MODEL:
      return {
        isOpen: true,
        result: comparisons(payload)
      };
    case types.RESET_COMPARISON:
      return initialState;
    default:
      return state;
  }
};
